<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
			<SettingSwitch :title="'Long text'" :switchValue.sync="longTextEnabled" />
			<SettingSwitch :title="'Prefill'" :switchValue.sync="prefillEnabled" />
			<div class="align-center mb-4 prefill-row display-flex flex-row width-100" v-if="prefillEnabled">
				<div class="width-100">
					<CombinedInputFieldDataMenu
						:value.sync="prefillValue"
						:textAreaMode="false"
						:attachTo="'.prefill-row'"
						:valuesTypes="dataInputMenuValueTypes"
						:richTextFormat="richTextFormat"
					/>
				</div>
			</div>
			<SettingSwitch :title="'Required'" :switchValue.sync="requiredEnabled" />
		</ExpansionPanel>
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
			<SettingSwitch
				:title="'Placeholder'"
				:placeholder="'Type placeholder text'"
				:switchValue.sync="placeholderEnabled"
				:textFieldValue.sync="placeholderValue"
			/>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

import { TEXT_BOX_FORMAT_TYPES } from '@/components/common/RichTextBox/rich-text-box.const';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

export default {
	name: 'RichTextInputFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
	},
	computed: {
		richTextFormat() {
			return TEXT_BOX_FORMAT_TYPES.HTML;
		},
		longTextEnabled: {
			get() {
				return this.localField.metadata.options.longText.enabled;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.longText.enabled', value);
			},
		},
	},
};
</script>
